import { useMutation } from "@tanstack/react-query";

import { env } from "@/config/env";
import { apiPaths } from "@/config/paths";
import { apiV2 } from "@/lib/api-client";
import type { MutationConfig } from "@/lib/react-query";
import { EnterpriseContactData } from "../types";


export const sendEnterpriseContactMessage = ({ data }: { data: EnterpriseContactData }) => {
  return apiV2.post<any, EnterpriseContactData>(apiPaths.support.sendEnterpriseContactMessage.getPath(), data, {
    baseURL: env.API_URL_WEB,
  });
};

type UseSendEnterpriseContactMessageOptions = {
  mutationConfig?: MutationConfig<typeof sendEnterpriseContactMessage>;
};

export const useSendEnterpriseContactMessage = ({ mutationConfig }: UseSendEnterpriseContactMessageOptions = {}) => {
  const { onSuccess, ...restConfig } = mutationConfig || {};

  return useMutation({
    onSuccess: (data, ...args) => {
      onSuccess?.(data, ...args);
    },
    ...restConfig,
    mutationFn: sendEnterpriseContactMessage,
  });
};
